import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import DashboardSummary from "./components/DashboardSummary";
import '../App.css';
import Main from '../App';
import moment from 'moment';

import React, { useEffect, useState } from "react";
import "moment/locale/id"; // pakai locale Indonesia

function Dashboard() {
  const [currentDate, setCurrentDate] = useState("");

  useEffect(() => {
    moment.locale("id"); // set locale Indo
    const updateDate = () => {
      const dateNow = moment().format("dddd, DD MMMM YYYY");
      setCurrentDate(dateNow);
    };

    updateDate(); // set pertama kali
    const interval = setInterval(updateDate, 60000); // update tiap 1 menit
    return () => clearInterval(interval);
  }, []);

  return (
    <Main>
      <div className="row">
        <div className="col-md-12">
          <h5 className="fw-semibold mb-3 text-dark">
            {currentDate} {/* ⬅️ tampilkan tanggal berjalan */}
          </h5>
          <DashboardSummary selectedMonth={moment().format("YYYY-MM")} />
        </div>
      </div>
    </Main>
  );
}

export default Dashboard;